import ICalendarFeedDetailApp from "ICalendarFeed/detail/app";
import {
  type RouteObject,
} from "react-router";
import { UserForExternalDetailApp } from "UserAdmin/UserForExternalAdmin/Detail/app";
import UserForExternalAdminListApp from "UserAdmin/UserForExternalAdmin/List/App";
import { UserForInternalDetailApp } from "UserAdmin/UserForInternalAdmin/Detail/app";
import UserForInternalAdminListApp from "UserAdmin/UserForInternalAdmin/List/App";
import { UserForInternalTransferApp } from "UserAdmin/UserForInternalAdmin/Transfer/app";

declare let viewModel: any;

export const userRoute: RouteObject = {
  path: "user",
  children: [{
    path: "internal",
    loader: () => viewModel,
    Component: UserForInternalAdminListApp,
  }, {
    path: "internal/detail/:key",
    loader: () => viewModel,
    Component: UserForInternalDetailApp,
  }, {
    path: "internal/transfer/:key",
    loader: () => viewModel,
    Component: UserForInternalTransferApp,
  }, {
    path: "external",
    loader: () => viewModel,
    Component: UserForExternalAdminListApp,
  }, {
    path: "external/detail/:key",
    loader: () => viewModel,
    Component: UserForExternalDetailApp,
  }, {
    path: ":userToClientId/icalendarfeed/:key",
    loader: () => viewModel,
    Component: ICalendarFeedDetailApp,
  }]
};